import React from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import API from "../../Services/BaseService";
import { useHistory, useLocation, useParams } from "react-router-dom";
import CommonPopup from '../../Component/CommonPopup/CommonPopup';
import checkImg from '../../assets/img/check.svg';
import errorImg from '../../assets/img/erroricon.png';
import "../../Component/CommonPopup/commonPopup.css"

const GatePassAccept=(props)=>{
  const history = useHistory();
  const [userName,setUserName] = useState("");
  const [password,setPassword] = useState("");
  // const { id } = useParams();
  const sellerData = useSelector(state => state.LoginReducer.payload);
  const [isCommonPopupOpen, setIsCommonPopupOpen] = useState(false);
	const [popupTitle, setPopupTitle] = useState("");
    const [popupMsg, setPopupMsg] = useState("");
    const [popupType, setPopupType] = useState("");
    const [popupActionType, setPopupActionType] = useState("");
    const [popupActionValue, setPopupActionValue] = useState("");
    const [popupActionPath, setPopupActionPath] = useState("");
    // const [userNameError,setUsernameError] = useState("");
    const [passwordError,setPasswordError] = useState("");
    const [alertmessage,setAlertMessage] = useState("");
    const [alerttitle,setAlertTitle] = useState("");
    const [alertimg,setAlertImg] = useState("");
    const email = sellerData.email;
   
    const [toggleAcceptPopupOpen,setToggleAcceptPopupOpen]= useState(true);
    const toggleCommonPopup = () => {
      setIsCommonPopupOpen(!isCommonPopupOpen);
  }
const handleAccepts=()=>{
  // setUsernameError("")
  // setPasswordError("")

//   if(!userName){
//     setUsernameError("Username is required")
//     return;
//   }
//   else if(userName && !new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i).test(userName)){
//     setUsernameError("Must match the email format")
// return;
//   }
//   if(!password){
//     setPasswordError("Password is required")
//     return;
//   }
//   else if(password && !new RegExp(/(^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,}))/).test(password)){
//     setPasswordError("Password must have minimum of 8 characters with the combination of upper ,lower case letters , number and a special character")
//     return;
// }

  
		let request ={
          seller_dealer_id:sellerData.seller_dealer_id, 
          seller_id:sellerData.seller_id, 
          car_id:props.carId, 
          // email:userName,
          // email:sellerData.email,
          // password:password,
          buyer_dealer_id:props.buyerId,
          active:1,
          createdBy:sellerData.seller_id,
          updatedBy:sellerData.seller_id
		}
	console.log("Gate Pass request: ",request);
		API.post("transportationStatus/add", request).then(response=>{
	
		console.log("===Gate Pass response===",response)
    if (response.data.success) {
      console.log("registration response=>", response)
      props.gatepassColorChange();
      setToggleAcceptPopupOpen(false);
       setAlertImg(checkImg);
       setAlertTitle("Successfully Updated")
       setAlertMessage("This car Transportation status has been updated to Picked Up")
     
  } else {
      const { data } = response;
      setToggleAcceptPopupOpen(false);
      setAlertImg(errorImg);
      setAlertMessage(data.error.err)
    
  }
	
    })
}
  return (
 
<div>
    <div id="" className="saveSearchBlock acceptConfirmation">
      
            <div className="termspageblock">
                <div className="row content">
                  {toggleAcceptPopupOpen?
                        (<div className="modalcontent">
                        
                            <div className="modalbody">
                              <h2 className="title"> Pickup Confirm </h2>
                              <div class="input-group col-md-12">
                                  <div>
                                      <p>Are you sure wants to  accept that the car has been picked up.</p>
                                      </div>
                                  
                              </div>
                          {/* <div class=" col-md-12">
                              <input className="textbox " type="text" placeholder="email" defaultValue={email} disabled />
                              </div>
								              	{/* <p className="form-input-error">{userNameError}</p> */}
 
                              {/* <div class=" col-md-12">
                              <input className="textbox " type="text" placeholder="Password" onChange={(e)=>setPassword(e.target.value)} />
                              </div>
								                	<p className="form-input-error">{passwordError}</p> */} 

                         <div class="col-md-12 btns">
                        <button className="cta-btns" onClick={props.toggle}>Cancel</button>    <button  className="cta-btns" onClick={handleAccepts}>Accept</button>    
                              </div>     
                            </div>
                       </div>):
                       (
                       <div className="modalcontent">
                        <div className="Commonfull-icon">
                        
                 		  <img alt="" className={alertimg === checkImg ?  "successImg " : "errorImg"} src={alertimg}></img>
                        
                        	</div>
                        <div className="modalbody">
                          <h2 className="title"> {alerttitle} </h2>
                          <div class="col-md-12">
                             
                                  <p class="text-center">{alertmessage}</p>
                                 
                              
                              <div class="col-md-12 btns">
                               <button className="cta-btns" onClick={props.toggle}>ok</button>      
                              </div> 
                          </div>
                        </div>
                       </div>)}
                       
                   </div>
              </div>
      </div>

      {isCommonPopupOpen && <CommonPopup
				handleClose={isCommonPopupOpen}
				popupTitle={popupTitle}
				popupMsg={popupMsg}
				popupType={popupType}
				popupActionType={popupActionType}
				popupActionValue={popupActionValue}
				popupActionPath={popupActionPath}
			/>}
      </div>
    )
    }

    export default GatePassAccept;